import { t } from '@/i18n/i18ns'

export default {
  name: 'DialogPopupPage',
  props: {
    pageId: {
      type: String,
      default: ''
    },
    showPrevButton: {
      type: Boolean,
      default: false
    },
    showNextButton: {
      type: Boolean,
      default: true
    },
    showFailButton: {
      type: Boolean,
      default: false
    },
    navigationPrev: {
      type: [String, Boolean],
      default: 'Cancel'
    },
    navigationNext: {
      type: [String, Boolean, null],
      default: 'Next'
    },
    navigationFail: {
      type: [String, Boolean, null],
      default: () => t('planUpgrade.tryAgain')
    },
    default: {
      type: [Boolean, String],
      default: false
    }
  }
}
